export const SUCCESS = 'ALERT_SUCCESS'
export const INFO = 'ALERT_INFO'
export const ERROR = 'ALERT_ERROR'
export const CLEAR = 'ALERT_CLEAR'

export const WARN = 'ALTER_WARN'
